interface HeadersInput {
  language?: string;
}

interface HeadersOutput {
  'Content-Language'?: string;
}

export default function formatHeaders({ language }: HeadersInput): HeadersOutput {
  return {
    'Content-Language': language,
  };
}
